// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useRouter } from "next/router";

import { MOMENT_LOCALE } from "src/configs/common";

const useMomentLocale = () => {
  const router = useRouter();
  const { locale } = router;
  const momentLocale = MOMENT_LOCALE(locale);

  return {
    momentLocale
  };
};

export default useMomentLocale;
